// import imgButtonEvent from 'assets/images/eventBoatRacingT10/img-button-event.png';
import imgButtonEvent from 'assets/images/eventBoatRacingT10/icon-boun-suang.webp';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function ButtonEvent() {
	const navigate = useNavigate()
	const location = useLocation()
	const [prevPath, setPrevPath] = useState(null);

	// const handleEvent = () => {
	// 	if (location.pathname === "/event-boat-racing") {
	// 		navigate(prevPath || "/");
	// 	} else {
	// 		setPrevPath(location.pathname);
	// 		navigate("/event-boat-racing");
	// 	}
	// };
	const handleEvent = () => {
		window.open(process.env.REACT_APP_LINK_WEB_KNIFE, "_blank");
	};

	return (
		<div onClick={handleEvent} className='button-event' >
			<img src={imgButtonEvent} alt="img-button-event" className="zoom-animation" />
		</div>
	)
}
